export { default } from "./useZoomInOutImage";
